module.exports = __webpack_public_path__ + "img/gemingyingxiong@3x.3242e087.png";